import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { TableColumn } from "../grid/grid.model";


@Pipe({
  name: 'dynamicFormat'
})
export class DynamicFormatPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {}

  transform(value: any, col: TableColumn): any {
    if (value === null || value === undefined || value === '') {
      return ''; 
    }

    switch (col.transformation) {
      case 'date':
        try {
           return this.datePipe.transform(value, 'dd.MM.yyyy');
        } catch {
           return value;
        }

      case 'datetime':
        try {
           return this.datePipe.transform(value, 'dd.MM.yyyy HH:mm');
        } catch {
           return value;
        }

      case 'boolean':
        let allowedValues = ['true', 'false', '0', '1'];
        let strValue = value.toString();
        if (allowedValues.includes(strValue)){
            return window.custom?.l10n?.localize('sdg.obecne.boolean.' + strValue);
        }
        return value;
      
      case 'localize':
        try {
          let strValue = value.toString();
          return window.custom?.l10n?.localize(col.transformationparameter + strValue);
        } catch {
          return value;
        }

      default:
        return value;
    }
  }
}
